var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankyouVipHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 82,
    viewBox: "0 0 343 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 343,
    height: 82
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 82,
    rx: 30,
    fill: "url(#paint0_radial)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M251.326 57.103C248.011 47.3418 239.13 39.3322 228.867 38.3582C219.178 37.4351 209.824 42.472 200.092 42.5665C184.356 42.7119 171.295 30.225 155.879 27.0634C137.963 23.3856 118.193 34.5206 112.037 51.7463C108.069 62.8667 110.097 75.6225 116.398 85.5509H248.491C252.99 76.829 254.473 66.3773 251.326 57.103Z",
    fill: "#E2EDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.954 58.6584C140.725 56.6669 152.063 47.5525 156.947 35.6253C157.972 33.1178 158.699 30.523 159.179 27.8846C159.084 27.8556 158.983 27.8265 158.888 27.8047C158.561 29.5781 158.139 31.3371 157.573 33.0669C155.581 39.194 151.896 44.6961 147.135 49.0207C142.411 53.309 136.618 56.4488 130.382 57.8952C123.928 59.3925 117.103 58.9709 110.809 56.9431C110.75 56.9286 110.7 56.9067 110.641 56.8849C110.62 56.9794 110.605 57.0739 110.591 57.1684C116.165 58.9927 122.14 59.5669 127.954 58.6584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.698 67.279C158.227 68.551 168.017 69.2342 177.437 66.8211C181.71 65.7236 185.839 63.9865 189.451 61.4499C193.085 58.8988 196.087 55.5626 198.471 51.834C200.375 48.854 201.865 45.6778 203.057 42.3926C202.956 42.3998 202.847 42.4144 202.745 42.4217C201.931 44.6457 200.979 46.8189 199.845 48.9267C197.65 53.0042 194.801 56.7692 191.225 59.7346C187.7 62.6637 183.528 64.7206 179.152 66.0434C169.914 68.8417 160.124 68.4202 150.653 67.2427C140.296 65.949 129.932 63.7685 119.443 64.2337C116.311 64.3717 113.135 64.7497 110.038 65.4256C110.046 65.5274 110.046 65.6292 110.053 65.7309C112.582 65.1713 115.155 64.8151 117.721 64.6261C128.114 63.8702 138.435 65.9126 148.698 67.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.971 74.1252C238.308 73.3184 234.696 72.1991 231.353 70.4838C228.242 68.8775 225.305 66.7479 223.227 63.8915C221.09 60.9551 220.072 57.4009 220.385 53.7813C220.973 47.1309 225.305 41.8105 230.909 38.6489C230.764 38.6198 230.626 38.598 230.48 38.5762C225.778 41.2945 222.027 45.4592 220.596 50.9322C219.68 54.4209 219.89 58.1278 221.424 61.413C222.892 64.5674 225.422 67.0895 228.278 69.0083C231.294 71.0362 234.703 72.4607 238.192 73.4637C242.371 74.6703 246.689 75.4116 251.028 75.6878C251.377 75.7096 251.725 75.7242 252.074 75.7387C252.096 75.6442 252.118 75.5497 252.14 75.448C248.716 75.2953 245.315 74.8593 241.971 74.1252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.757 35.3057C166.418 33.9101 167.16 32.551 167.966 31.2427C167.879 31.1991 167.785 31.1628 167.697 31.1191C167.116 32.064 166.571 33.0234 166.069 34.0119C164.812 36.4686 163.802 39.0561 163.06 41.7162C162.253 44.6235 161.57 47.8143 162.319 50.8088C162.893 53.1201 164.405 55.2788 166.709 56.1074C169.311 57.045 172.138 56.071 174.442 54.7991C176.95 53.4109 179.254 51.5502 181.427 49.6895C183.615 47.8143 185.679 45.801 187.605 43.6569C188.383 42.7919 189.131 41.9052 189.858 41.004C189.756 40.9749 189.655 40.9458 189.553 40.9095C186.035 45.2559 181.972 49.1589 177.451 52.4732C175.133 54.174 172.523 55.8893 169.594 56.1582C166.68 56.4272 164.238 54.7482 163.082 52.1244C161.803 49.2098 162.326 45.8955 163.06 42.9155C163.693 40.2989 164.601 37.7478 165.757 35.3057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.079 66.5297C247.096 66.6896 250.119 65.941 252.881 64.6254C252.874 64.5382 252.867 64.451 252.859 64.3638C250.57 65.4467 248.099 66.1154 245.518 66.239C242.626 66.3771 239.675 65.6212 237.523 63.6152C235.583 61.8054 234.609 59.167 235.35 56.565C235.677 55.4093 236.331 54.3263 237.269 53.5632C238.49 52.5747 240.067 52.3203 241.594 52.2767C242.967 52.2331 244.348 52.3348 245.715 52.1604C246.71 52.0296 247.684 51.7606 248.615 51.3609C248.564 51.2809 248.513 51.1937 248.462 51.1138C248.157 51.2446 247.851 51.3609 247.539 51.4554C244.719 52.3566 241.703 51.4844 238.904 52.3784C236.717 53.0762 235.263 55.0314 234.899 57.2554C234.514 59.5885 235.386 61.8562 237.015 63.5279C238.875 65.4322 241.448 66.3916 244.079 66.5297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.329 76.138C215.021 73.0272 213.712 69.9091 212.411 66.7983C211.496 64.6178 210.536 62.2483 208.559 60.802C206.473 59.2829 203.646 59.2829 201.313 60.2132C198.842 61.2017 196.879 63.1205 195.2 65.1338C191.864 69.1459 189.466 73.9139 188.135 78.9508C187.569 81.1094 187.191 83.319 187.023 85.5431H187.321C187.823 79.0307 190.069 72.6492 193.877 67.3143C195.433 65.1338 197.25 62.9606 199.51 61.4779C201.836 59.9516 204.94 59.2175 207.542 60.5112C209.918 61.696 211.045 64.2835 212.019 66.5948C213.233 69.4875 214.447 72.373 215.66 75.2658C217.099 78.6891 218.539 82.1125 219.97 85.5358H220.283C218.967 82.4105 217.645 79.2778 216.329 76.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M203.959 21.6993C202.076 21.7575 200.179 21.6775 197.991 20.8853C193.325 19.1918 187.511 21.9683 187.467 27.354C187.438 31.5333 191.283 34.3025 194.844 35.5744C201.56 37.9802 215.472 36.7155 214.817 26.7362C214.607 23.5455 212.913 22.0555 209.853 21.7066C207.702 21.4595 205.834 21.6485 203.959 21.6993Z",
    fill: "#E2EDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.826 56.4347L176.579 56.4492V53.5928C176.579 52.5825 177.393 51.7612 178.403 51.7612L186.994 51.7539C188.005 51.7539 188.826 52.5679 188.826 53.5782V56.4347Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66 39.3613H178.738V53.389H186.66V39.3613Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.738 45.423V39.3613H186.66L186.653 42.305L178.738 45.423Z",
    fill: "#E8950C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.327 28.539L195.818 26.8673C205.093 24.0617 209.025 18.2544 207.84 9.12548C207.826 9.11094 207.731 9.0528 207.607 9.08914L206.328 9.43801C205.819 9.57611 205.471 9.96133 205.471 10.3902V12.3671C205.471 13.5664 204.46 14.5258 203.167 14.5549C201.829 14.5839 199.54 14.6203 199.242 14.6203V12.8759C199.452 12.8759 200.906 12.8468 203.137 12.8105C203.457 12.8032 203.733 12.5997 203.733 12.3671V10.3902C203.733 9.16182 204.598 8.10066 205.878 7.75178L207.157 7.4029C207.716 7.25027 208.312 7.34476 208.792 7.66456C209.228 7.95529 209.512 8.40592 209.577 8.90016C210.202 13.6972 209.504 17.7529 207.498 20.9364C205.332 24.3961 201.568 26.9545 196.327 28.539Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.064 28.539C163.816 26.9545 160.058 24.3961 157.892 20.9437C155.886 17.7602 155.189 13.7045 155.814 8.90749C155.879 8.41325 156.163 7.96261 156.599 7.67188C157.078 7.35208 157.674 7.25759 158.234 7.41023L159.513 7.7591C160.793 8.10798 161.657 9.16188 161.657 10.3975V12.3744C161.657 12.607 161.934 12.8105 162.253 12.8178C164.485 12.8614 165.938 12.8832 166.149 12.8832V14.6276C165.844 14.6276 163.554 14.584 162.224 14.5622C160.931 14.5404 159.92 13.581 159.92 12.3744V10.3902C159.92 9.96138 159.579 9.57616 159.063 9.43807L157.783 9.08919C157.66 9.05285 157.565 9.111 157.551 9.14007C156.373 18.2544 160.306 24.0618 169.58 26.8673L169.064 28.539Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.136 9.30705L198.239 32.9797C198.013 35.8143 196.625 38.3074 194.575 39.9936C192.824 41.4327 190.578 42.2976 188.143 42.2976H177.255C171.978 42.2976 167.581 38.2419 167.16 32.9797L166.178 20.6964L165.263 9.30705C165.117 7.52633 166.527 6 168.315 6H197.083C198.871 6 200.281 7.52633 200.136 9.30705Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.575 39.9935C192.824 41.4326 190.578 42.2975 188.143 42.2975H177.255C171.978 42.2975 167.581 38.2418 167.159 32.9796L166.178 20.6963C173.076 29.4182 184.073 36.8972 194.575 39.9935Z",
    fill: "#E8950C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.608 42.1523H177.255V42.4431H188.608V42.1523Z",
    fill: "#001F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.511 51.6157H178.404V51.9065H180.511V51.6157Z",
    fill: "#001F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.053 51.6157H184.945V51.9065H187.053V51.6157Z",
    fill: "#001F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.675 63.3612L173.723 63.383L173.715 58.6441C173.715 56.878 175.147 55.4389 176.913 55.4389L188.455 55.4243C190.222 55.4243 191.661 56.8562 191.661 58.6223L191.675 63.3612Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.812 55.3149H176.586V55.6057H188.812V55.3149Z",
    fill: "#E8950C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M192.031 19.3371C192.914 19.3371 193.63 17.9379 193.63 16.2118C193.63 14.4857 192.914 13.0864 192.031 13.0864C191.148 13.0864 190.432 14.4857 190.432 16.2118C190.432 17.9379 191.148 19.3371 192.031 19.3371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.752 78.1162H138.704V85.6025H226.752V78.1162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.208 70.6304H153.255V78.1167H212.208V70.6304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.011 63.1431H163.453V70.6294H202.011V63.1431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.417 78.1162H161.04V85.6025H204.417V78.1162Z",
    fill: "#FF5C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.173 70.6304H167.283V78.1167H198.173V70.6304Z",
    fill: "#FF5C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.763 63.1431H173.687V70.6294H191.763V63.1431Z",
    fill: "#FF5C33"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.694 68.8784H163.453V70.6228H173.694V68.8784Z",
    fill: "#003E80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M202.011 68.8784H191.77V70.6228H202.011V68.8784Z",
    fill: "#003E80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M191.763 68.8784H173.687V70.6228H191.763V68.8784Z",
    fill: "#4A191B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M167.283 76.3574H153.255V78.1018H167.283V76.3574Z",
    fill: "#003E80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M212.201 76.3574H198.173V78.1018H212.201V76.3574Z",
    fill: "#003E80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M198.173 76.3574H167.283V78.1018H198.173V76.3574Z",
    fill: "#4A191B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.85 85.6028H138.559V77.9711L153.11 77.9566V70.4848L163.307 70.4776V62.9985H173.621V63.2893H163.598V70.7683L153.401 70.7756V78.2473L138.85 78.2618V85.6028Z",
    fill: "#95BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.897 85.6023H226.606V78.2614L212.055 78.2468V70.7751L201.858 70.7678L201.865 63.2888H191.675V62.998H202.156L202.149 70.4771L212.346 70.4843V77.9561L226.897 77.9706V85.6023Z",
    fill: "#95BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.499 60.0324C315.331 58.2482 311.804 55.1516 307.825 50.599L309.507 47.0103C313.69 52.5472 315.044 55.5413 320.273 55.1106L320.499 60.0324Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.102 73.5262C245.668 74.8797 241.136 74.1004 235.599 72.2753L235.578 68.0713C241.73 70.6757 244.253 72.6034 248.785 69.1992L251.102 73.5262Z",
    fill: "#14CCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.283 56.3823C108.72 60.0326 105.828 62.0013 101.932 63.888L100.271 61.4886C104.803 59.7045 106.997 59.4789 108.248 55.1313L111.283 56.3823Z",
    fill: "#FF5C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9661 58.0635C28.3109 54.6798 25.8705 50.5169 23.5327 44.8158L26.7113 41.8423C28.8646 48.5687 29.0902 51.9319 34.6887 53.1828L32.9661 58.0635Z",
    fill: "#14CCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.564 4.49869C207.155 2.32492 204.284 -0.833202 201.167 -5.30379L202.972 -8.27734C206.191 -2.90444 207.134 -0.0949402 211.79 0.13064L211.564 4.49869Z",
    fill: "#14CCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.612 20.6736C278.955 18.8108 281.494 15.76 284.518 11.3362L284.021 7.99792C280.738 13.3735 279.507 16.2463 276.441 16.0135L275.612 20.6736Z",
    fill: "#8BE742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.68 19.8957C239.126 18.2315 241.839 15.3345 245.117 11.0951L244.816 7.73353C241.224 12.9078 239.827 15.7038 236.78 15.292L235.68 19.8957Z",
    fill: "#F35256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3066 33.0858C83.4392 33.0858 84.3573 32.1677 84.3573 31.0351C84.3573 29.9025 83.4392 28.9844 82.3066 28.9844C81.174 28.9844 80.2559 29.9025 80.2559 31.0351C80.2559 32.1677 81.174 33.0858 82.3066 33.0858Z",
    fill: "#FF5C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.278 33.0858C246.411 33.0858 247.329 32.1677 247.329 31.0351C247.329 29.9025 246.411 28.9844 245.278 28.9844C244.145 28.9844 243.227 29.9025 243.227 31.0351C243.227 32.1677 244.145 33.0858 245.278 33.0858Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.051 53.1015C273.183 53.1015 274.101 52.1833 274.101 51.0507C274.101 49.9181 273.183 49 272.051 49C270.918 49 270 49.9181 270 51.0507C270 52.1833 270.918 53.1015 272.051 53.1015Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.051 60.1015C134.183 60.1015 135.101 59.1833 135.101 58.0507C135.101 56.9181 134.183 56 133.051 56C131.918 56 131 56.9181 131 58.0507C131 59.1833 131.918 60.1015 133.051 60.1015Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.051 15.1015C121.183 15.1015 122.101 14.1833 122.101 13.0507C122.101 11.9181 121.183 11 120.051 11C118.918 11 118 11.9181 118 13.0507C118 14.1833 118.918 15.1015 120.051 15.1015Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0507 10.1015C47.1833 10.1015 48.1015 9.18331 48.1015 8.05073C48.1015 6.91814 47.1833 6 46.0507 6C44.9181 6 44 6.91814 44 8.05073C44 9.18331 44.9181 10.1015 46.0507 10.1015Z",
    fill: "#1CD5D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(515.883 8.43142) rotate(171.721) scale(556.257 2148.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0545299,
    stopColor: "#FF3767",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FF5864",
    stopOpacity: 0.990635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BB19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyouVipHeader);
export default __webpack_public_path__ + "static/media/thankyou-vip-header.8207c0ae40e3469c689cf40edf54ff8b.svg";
export { ForwardRef as ReactComponent };